module.exports = __webpack_public_path__ + "static/media/18.33378850.jpg";